import appServices from '@/services/appServices';
import { useQuery } from '@tanstack/react-query';

export default function useMerchants() {
  const query = useQuery({
    queryKey: ['merchants'],
    queryFn: () => appServices.merchants.getMerchants(),
  });

  return {
    merchants: query.data?.data ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
  };
}
